/**
 * 隱私權政策完整內容
 * 🔒 此檔案為獨立資料檔,不會被其他檔案覆蓋
 */
export const privacyContent = {
  title: "隱私權政策",
  titleEn: "Privacy Policy",
  effectiveDate: "2026 年 4 月 3 日",
  introduction: `「未眠酒吧 Midnight Bar」(以下簡稱「我們」或「本服務」) 重視您的隱私權。本隱私權政策說明我們如何收集、使用、儲存及保護您的個人資料。使用本服務即表示您同意本政策的內容。`,
  
  sections: [
    {
      id: 1,
      title: "我們收集哪些資料",
      subsections: [
        {
          subtitle: "1.1 您主動提供的資料",
          list: [
            `<strong>帳戶資訊:</strong> Email、密碼 (加密儲存)、姓名 (可選)`,
            `<strong>對話內容:</strong> 您與 AI 角色的對話訊息`,
            `<strong>塔羅記錄:</strong> 您的占卜問題與抽牌結果`,
            `<strong>付款資訊:</strong> 透過第三方支付處理商 (Stripe) 處理,我們不儲存完整信用卡資訊`
          ]
        },
        {
          subtitle: "1.2 自動收集的資料",
          list: [
            `<strong>使用數據:</strong> 登入時間、功能使用頻率、對話長度`,
            `<strong>裝置資訊:</strong> IP 位址、瀏覽器類型、作業系統`,
            `<strong>Cookies:</strong> 用於維持登入狀態與分析使用行為`
          ]
        }
      ]
    },
    {
      id: 2,
      title: "我們如何使用您的資料",
      list: [
        `<strong>提供服務:</strong> 儲存對話歷史、塔羅記錄,讓您隨時查看`,
        `<strong>帳戶管理:</strong> 驗證身份、處理訂閱與付款`,
        `<strong>改善服務:</strong> 分析使用數據以優化 AI 回應品質`,
        `<strong>客戶支援:</strong> 回應您的問題與技術支援請求`,
        `<strong>安全防護:</strong> 偵測並防止詐欺、濫用或違規行為`,
        `<strong>法律義務:</strong> 遵守適用的法律法規`
      ]
    },
    {
      id: 3,
      title: "資料分享與揭露",
      content: `我們<strong class="text-amber-300">不會出售</strong>您的個人資料。但在以下情況下,我們可能分享您的資料:`,
      subsections: [
        {
          subtitle: "3.1 服務提供商",
          list: [
            `<strong>NoCodeBackend (NCB):</strong> 後端資料庫服務商`,
            `<strong>Stripe:</strong> 付款處理商`,
            `<strong>OpenAI / Google AI:</strong> AI 語言模型提供商 (僅處理對話內容,不包含個人身份資訊)`,
            `<strong>Cloudflare:</strong> CDN 與安全防護服務`
          ],
          note: `這些服務商均受嚴格的資料保護協議約束。`
        },
        {
          subtitle: "3.2 法律要求",
          content: `如法律、法院命令或政府機關要求,我們可能被迫揭露您的資料。`
        },
        {
          subtitle: "3.3 業務轉讓",
          content: `若本服務被收購或合併,您的資料可能轉移至新的所有者,但隱私保護標準不變。`
        }
      ]
    },
    {
      id: 4,
      title: "資料安全措施",
      content: `我們採取以下措施保護您的資料:`,
      list: [
        `<strong>加密傳輸:</strong> 所有資料透過 HTTPS 加密傳輸`,
        `<strong>密碼保護:</strong> 密碼使用業界標準的加密演算法儲存`,
        `<strong>存取控制:</strong> 僅授權人員可存取使用者資料`,
        `<strong>定期備份:</strong> 防止資料遺失`,
        `<strong>安全監控:</strong> 持續監控異常活動`
      ],
      warning: `然而,沒有任何系統是 100% 安全的。我們建議您使用強密碼並妥善保管帳戶憑證。`
    },
    {
      id: 5,
      title: "資料保留期限",
      list: [
        `<strong>帳戶資料:</strong> 在您刪除帳戶後 30 天內永久刪除`,
        `<strong>對話歷史:</strong> 保留至帳戶刪除或您主動刪除`,
        `<strong>付款記錄:</strong> 依法律要求保留 7 年 (用於稅務與會計目的)`,
        `<strong>使用日誌:</strong> 保留 90 天後自動刪除`
      ]
    },
    {
      id: 6,
      title: "您的權利",
      content: `根據適用的資料保護法律 (如 GDPR、CCPA),您擁有以下權利:`,
      list: [
        `<strong>存取權:</strong> 您可以要求查看我們持有的您的個人資料`,
        `<strong>更正權:</strong> 您可以要求更正不正確的資料`,
        `<strong>刪除權:</strong> 您可以要求刪除您的帳戶與資料 (「被遺忘權」)`,
        `<strong>可攜權:</strong> 您可以要求以常見格式匯出您的資料`,
        `<strong>反對權:</strong> 您可以反對我們處理您的資料 (在某些情況下)`,
        `<strong>限制處理:</strong> 您可以要求限制我們如何使用您的資料`
      ],
      contact: `如需行使上述權利,請聯繫: info@homy.hk`
    },
    {
      id: 7,
      title: "Cookies 與追蹤技術",
      subsections: [
        {
          subtitle: "7.1 我們使用的 Cookies",
          list: [
            `<strong>必要 Cookies:</strong> 維持登入狀態 (無法停用)`,
            `<strong>功能性 Cookies:</strong> 記住您的偏好設定`,
            `<strong>分析 Cookies:</strong> 了解使用者如何使用服務 (可選)`
          ]
        },
        {
          subtitle: "7.2 如何管理 Cookies",
          content: `您可以透過瀏覽器設定管理 Cookies,但停用必要 Cookies 可能影響服務功能。`
        }
      ]
    },
    {
      id: 8,
      title: "兒童隱私",
      content: `本服務僅供 <strong class="text-amber-300">18 歲以上</strong>成年人使用。我們不會故意收集未成年人的個人資料。如果您發現我們誤收集了未成年人的資料,請立即聯繫我們,我們將盡快刪除。`
    },
    {
      id: 9,
      title: "國際資料傳輸",
      content: `您的資料可能被傳輸至您所在國家/地區以外的伺服器進行處理。我們會確保這些傳輸符合適用的資料保護法律,並採取適當的安全措施。`
    },
    {
      id: 10,
      title: "第三方連結",
      content: `本服務可能包含第三方網站的連結 (如 Google OAuth 登入)。我們不對這些第三方的隱私政策負責,建議您在使用前閱讀其隱私政策。`
    },
    {
      id: 11,
      title: "隱私政策變更",
      content: `我們可能不時更新本隱私政策。重大變更將透過 Email 或網站公告通知您。請定期查看本頁面以了解最新版本。`
    },
    {
      id: 12,
      title: "聯絡我們",
      content: `如對本隱私政策有任何疑問,或希望行使您的資料權利,請聯繫:`,
      contact: {
        email: "info@homy.hk",
        website: "https://bar.homy.hk"
      }
    }
  ],
  
  footer: `使用本服務即表示您已閱讀、理解並同意本隱私權政策。`
};